import type { ReactNode } from 'react';

/**
 * Figma 7453:980's columns (ID 110, Categories 170, Address 268, Status 140, Assignee(s) 130,
 * Priority 110, Created 190, Actions 60 of 1178). Address has no width: it takes what's left, as
 * on Service Requests, and grows when Manage Columns hides a column. The optional columns aren't
 * drawn; their widths fit their content.
 */
export const WORK_ORDER_LIST_COLUMN_WIDTHS = {
  id: 'w-[110px]',
  categories: 'w-[170px]',
  status: 'w-[140px]',
  assignee: 'w-[130px]',
  priority: 'w-[110px]',
  created: 'w-[190px]',
  actions: 'w-[60px]',
  market: 'w-[110px]',
  technician: 'w-[130px]',
  provider: 'w-[150px]',
  dueDate: 'w-[120px]',
  healthScore: 'w-[140px]',
  scheduled: 'w-[190px]',
  tags: 'w-[170px]',
  totalCost: 'w-[140px]',
} as const;

/**
 * Each column's floor (px): the fixed columns' widths, and Address at 261, what the frame's 268
 * comes to inside the list box at the 1456 design width (its two borders and 5px scrollbar sit
 * inside Figma's 1178). Past the sum the table scrolls sideways in its own box.
 */
export const WORK_ORDER_LIST_COLUMN_MIN_WIDTHS = {
  id: 110,
  categories: 170,
  address: 261,
  status: 140,
  assignee: 130,
  priority: 110,
  created: 190,
  actions: 60,
  market: 110,
  technician: 130,
  provider: 150,
  dueDate: 120,
  healthScore: 140,
  scheduled: 190,
  tags: 170,
  totalCost: 140,
} as const;

/**
 * A cell kept on one line with an ellipsis, like the drawn columns ("No invoices yet" wrapped to two
 * in a 120 column, and a long Provider in its 150 column, each making the row 64). A block child
 * (the legacy Market `<div>`, Total Cost's `<p>`) truncates too.
 */
export const ListNoWrapCell = ({ children }: { children: ReactNode }) => (
  <span className="block truncate [&>*]:truncate">{children}</span>
);
